module.exports = __webpack_public_path__ + "static/media/money.632ec71a.svg";